import React, { useState } from "react";
import ImagesDisplay from "../components/ImagesDisplay/ImagesDisplay";
import styles from "./page.default.module.css";
import { useTranslation } from "react-i18next";

const Gallery: React.FC = () => {
  const { t } = useTranslation();
  const [selectedConcert, setSelectedConcert] = useState<string | null>(null);

  return (
    <section className={styles.pageSection}>
      <div className={styles.container}>
        {!selectedConcert && (
          <div className={styles.heading}>
            <h1 className={styles.title}>{t("gallery.title")}</h1>
            <p className={styles.description}>{t("gallery.description")}</p>
          </div>
        )}
        <ImagesDisplay setSelectedConcert={setSelectedConcert} />
      </div>
    </section>
  );
};

export default Gallery;
